import type { FeatureFlagSet } from "../lib/featureFlags/types";

export const UNIZO_FEATURE_FLAGS = {
  continueMeeting: {
    label: "商談の続きを記録",
    description: "グループ内の前回商談から企業・担当者を引き継いで記録開始",
    defaultValue: false,
  },
  pushNotifications: {
    label: "Push通知(Chrome)",
    description:
      "Chromeブラウザへのweb push通知を有効化。設定画面にPushバナーと許可ボタンを表示",
    defaultValue: false,
  },
  meetingNlSearch: {
    label: "AIエージェント検索 (Stage 1)",
    description: "自然言語で商談を検索する API エンドポイントを有効化（メタデータフィルタ）",
    defaultValue: false,
  },
  meetingNlSearchVector: {
    label: "AIエージェント検索: ベクトル検索 (Stage 3)",
    description: "S3 Vectors による意味検索を有効化（meetingNlSearch との併用）",
    defaultValue: false,
  },
  meetingNlSearchRerank: {
    label: "AIエージェント検索: LLM rerank (Stage 3)",
    description: "検索結果を LLM で再ランキング（meetingNlSearch との併用）",
    defaultValue: false,
  },
  companyExternalSystemId: {
    label: "全店顧客番号入力（商談編集画面）",
    description:
      "商談編集画面の取引先名の下に「全店顧客番号」(企業マスタ systemIntegrationId) の入力欄を表示し、保存時に企業マスタへ反映する。基幹システム側の顧客番号を商談に紐づけて運用するテナント向け。OFFで非表示・既存挙動のまま (PRODUCT_DEV-557)。",
    defaultValue: false,
  },
  aiVoiceVolumeSlider: {
    label: "AI音声 音量スライダー",
    description:
      "録音画面に AI 音声出力の音量スライダーを表示 (全 OS)。再生経路は iOS/iPadOS のみ Web Audio(GainNode) で音量制御し (iOS Safari は audio.volume を黙殺するため PRODUCT_DEV-556)、Android/PC は従来の audio.volume 経路 (PRODUCT_DEV-605: Android で AudioContext がメディア音量に固定され側面ボタンの通話音量と食い違うデグレを修正)。OFF は全 OS で従来経路のまま (PRODUCT_DEV-541)。",
    defaultValue: false,
  },
  guideRenewal: {
    label: "使い方ガイド（新版）",
    description:
      "ONのテナントは刷新後の使い方ガイドを表示する。OFFは現行ガイド（回帰なし）。自社テナント先行検証→100%展開用 (PRODUCT_DEV-560)。",
    defaultValue: false,
  },
  sansanContactRegistration: {
    label: "Sansanコンタクト連携",
    description:
      "商談詳細に「Sansanへ登録」ボタンを表示し、商談をSansanのコンタクト(接点記録)として登録するAPI連携を有効化。自社テナント先行検証(PoC)→将来テナント別展開 (PRODUCT_DEV-531)。",
    defaultValue: false,
  },
  inquiryQa: {
    label: "問い合わせ前のAI Q&A",
    description:
      "お問い合わせ一覧の主導線を「質問する」に変え、問い合わせフォームの手前にAI Q&Aを挟む。使い方ガイドを根拠にLLMがその場で回答し、解決しない場合は質問とAI回答を引き継いで従来のフォームへ進む。回答は運営の承認を経ずユーザへ直接届く(既存の問い合わせAIドラフトとはここが異なる)。不具合報告・要望などQ&Aが噛み合わない用件のために「運営に直接問い合わせる」副導線を併置する。OFFは現行どおり「新しく問い合わせる」から直接フォームへ、/inquiries/qa も遮断（回帰なし） (PRODUCT_DEV-690)。",
    defaultValue: false,
  },
  scheduling: {
    label: "日程調整",
    description:
      "マイページに日程調整を出す。候補日時を作って相手へワンタイムリンクを送り、相手はログインせずに候補ごとの ○△× で答える。確定・日時変更・取り消しはメールと .ics で相手に届く。OFF のときはマイページの行が「準備中」表示のままで、/mypage/scheduling も遮断する（回帰なし）。**相手の回答画面 /s/:token はフラグで塞がない** — 相手のテナントは判別できず、リンクが死ぬ方が害が大きいため (PRODUCT_DEV-675)。",
    defaultValue: false,
  },
  schedulingCalendarSync: {
    label: "日程調整: 外部カレンダー連携",
    description:
      "日程調整で Google カレンダー / Microsoft 365 の予定を読み、候補日時の空き判定に混ぜる。ON のテナントだけ「カレンダーをつなぐ」案内と接続導線を出す。⚠ **連携そのものはまだ実装していない**。このフラグは先に置いてあるだけで、OFF のあいだは案内カード（つなぐ先が無いのに「つなぐと正確になります」とだけ出て、どこからも接続できない）を丸ごと出さないために使う。既定 OFF (PRODUCT_DEV-675)。",
    defaultValue: false,
  },
  minutesMeetingLink: {
    label: "議事録と商談記録の紐づけ",
    description:
      "商談詳細に「関連議事録」(タイトル/日付/AI要約)を表示し、編集画面から追加・解除できるようにする。あわせて議事録詳細に「商談の振り返りを記録」を追加し、議事録要約を差し込んだ対話で当日の顧客の反応(声色・仕草・表情など)を聞き出して商談記録として保存する。振り返りのプロンプトは Admin ONP「振り返り記録プロンプト」タブで管理(フリーテキスト)。要約は商談詳細でテナント全員に見えるが、議事録本体・全文の閲覧範囲は従来どおり本人＋管理者のみ。OFFは現行どおり議事録詳細から片方向に紐づけるのみ（回帰なし） (PRODUCT_DEV-612)。",
    defaultValue: false,
  },
  csMeetingNotification: {
    label: "商談記録の運営 Slack 通知",
    description:
      "このテナントで商談記録が作成されるたび、運営(カスタマーサクセス)の Slack チャンネルへ商談タイトル・プリセット名・記録モード・商談詳細リンクを送信する。商談タイトルには顧客名や個人名が含まれうるため、テナントの合意が取れている場合にのみ ON にすること。テナント向けの通知 Webhook (PRODUCT_DEV-379) とは別系統で、キーワード判定はせず全件が対象。OFFで送信しない (PRODUCT_DEV-495 / PRODUCT_DEV-735)。",
    defaultValue: false,
  },
} as const satisfies FeatureFlagSet;

export type UnizoFeatureFlagKey = keyof typeof UNIZO_FEATURE_FLAGS;
